import type { CrudConfig } from '@/components/GenericCrudPage';

export const couponsConfig: CrudConfig = {
  resource: 'coupons',
  title: '优惠券管理',
  rowKey: 'id',
  searchFields: ['code', 'discount_type', 'is_active'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'code', label: '优惠码', type: 'text', required: true, copyable: true, width: 160 },
    { name: 'name', label: '名称', type: 'text', required: true, ellipsis: true },
    {
      name: 'discount_type',
      label: '折扣类型',
      type: 'select',
      required: true,
      width: 120,
      options: [
        { label: '百分比', value: 'PERCENT', color: 'blue' },
        { label: '满减', value: 'FIXED', color: 'green' },
        { label: '免单', value: 'FREE', color: 'gold' },
      ],
    },
    { name: 'discount_value', label: '折扣值', type: 'number', required: true, width: 110, hideInSearch: true, tooltip: 'PERCENT 填 1-100, FIXED 填金额' },
    { name: 'min_order_amount', label: '最低订单', type: 'number', width: 110, hideInSearch: true },
    { name: 'usage_limit', label: '总使用次数', type: 'number', width: 110, hideInSearch: true },
    { name: 'used_count', label: '已使用', type: 'readonly', width: 100, hideInForm: true, readonly: true },
    { name: 'valid_from', label: '生效时间', type: 'datetime', width: 180, hideInSearch: true },
    { name: 'valid_to', label: '失效时间', type: 'datetime', width: 180, hideInSearch: true },
    { name: 'is_active', label: '启用', type: 'boolean', width: 90 },
  ],
};
